'use client';

import { useEffect } from 'react';

let activeSockets: WebSocket[] = [];

export function WebSocketCleanup() {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        activeSockets.forEach(socket => {
          if (socket.readyState === WebSocket.OPEN) {
            socket.close();
          }
        });
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null;
}

// Function to add a WebSocket to the list
export function addWebSocket(socket: WebSocket) {
  activeSockets.push(socket);
}

// Function to remove a WebSocket from the list
export function removeWebSocket(socket: WebSocket) {
  activeSockets = activeSockets.filter(s => s !== socket);
} 